// Web Presence v2 — serializable icon registry. Craft node props must be JSON,
// so icons are stored by NAME and resolved to lucide components here. Used by
// the IconPicker and by TrivenyHero (launcher icon overrides).
import {
  LayoutTemplate, Mail, ClipboardList, Send, Target, Users, Eye, PhoneCall,
  BarChart3, KanbanSquare, Brain, PlusCircle, CalendarClock, Inbox, Headphones,
  Sparkles, Rocket, Star, Heart, Zap, Shield, Globe, Megaphone, Calendar,
  MessageSquare, FileText, Image as ImageIcon, Video, Phone, Check, ArrowRight,
  TrendingUp, DollarSign, Layers, Settings, Search, Bell, type LucideIcon,
} from 'lucide-react';

export const ICON_REGISTRY: Record<string, LucideIcon> = {
  LayoutTemplate, Mail, ClipboardList, Send, Target, Users, Eye, PhoneCall,
  BarChart3, KanbanSquare, Brain, PlusCircle, CalendarClock, Inbox, Headphones,
  Sparkles, Rocket, Star, Heart, Zap, Shield, Globe, Megaphone, Calendar,
  MessageSquare, FileText, Image: ImageIcon, Video, Phone, Check, ArrowRight,
  TrendingUp, DollarSign, Layers, Settings, Search, Bell,
};
export const ICON_NAMES = Object.keys(ICON_REGISTRY);
export function resolveIcon(name?: string): LucideIcon | undefined {
  return name ? ICON_REGISTRY[name] : undefined;
}
